import { render } from "./MarketingConsentOverview.vue?vue&type=template&id=d0ea5b7c&scoped=true"
import script from "./MarketingConsentOverview.vue?vue&type=script&lang=js"
export * from "./MarketingConsentOverview.vue?vue&type=script&lang=js"

import "./MarketingConsentOverview.vue?vue&type=style&index=0&id=d0ea5b7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ea5b7c"]])

export default __exports__